import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

import { useSectionContext } from '../Section/Section.context';

export const DeletePhotoAlbumSectionDialog = () => {
  const { sectionIndex, sectionsFieldArray } = useSectionContext();
  const { t } = useTranslation(['common', 'lines']);

  const deleteSection = useCallback(() => {
    sectionsFieldArray.remove(sectionIndex);
  }, [sectionIndex, sectionsFieldArray]);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('lines:photoAlbum.deleteDialog.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('lines:photoAlbum.deleteDialog.description')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button emphasis="status" icon="Trash" onClick={deleteSection}>
          {t('common:actions.delete')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
